import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
// import { navigateTo } from 'gatsby-link';
import { reduxForm/* , SubmissionError */ } from 'redux-form';
import Form from '../blocks/Form';
import Field from '../fields/Field';
import Label from '../text/Label';
import Message from '../text/Message';
import InputField from '../fields/InputField';
import CreateButton from '../buttons/CreateButton';
import HeavyLink from '../links/HeavyLink';
import Block from '../blocks/Block';
import Text from '../text/Text';
import LinkButtonLink from '../links/LinkButtonLink';

class BetaSignupForm extends React.PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    showLabels: PropTypes.bool,
    valid: PropTypes.bool,
    submitSucceeded: PropTypes.bool,
    small: PropTypes.bool,
    inverse: PropTypes.bool,
  };

  static defaultProps = {
    showLabels: false,
    valid: false,
    submitSucceeded: false,
    small: false,
    inverse: false,
  };

  render() {
    const {
      small,
      inverse,
      showLabels = false,
      valid,
      submitSucceeded,
      handleSubmit,
    } = this.props;
    return !submitSucceeded ? (
      <Form onSubmit={handleSubmit}>
        <Field>
          {showLabels && (<Label>Email Address</Label>)}
          <InputField
            inverse={inverse}
            name="email"
            type="text"
            placeholder="Email Address"
          />
        </Field>
        <div className="actions">
          <CreateButton
            bold
            fluid={small}
            inverse={inverse}
            disabled={!valid}
          >Sign up for the Beta</CreateButton>
        </div>
        {/* <div className={classnames(styles.inner_block, styles.text, styles.text_center)}>
          By signing up, you agree to our <Link
            to="/privacy"
            className={styles.heavy_link}
          >Privacy Policy</Link> & <Link
            to="/terms"
            className={styles.heavy_link}
          >Terms of Service</Link>.
        </div> */}
      </Form>
    ) : (
      <div>
        <Message>
          Thank you, you will hear back from us soon.
        </Message>
        {!small && (
          <Block>
            <Text>
              Go back to <HeavyLink
                to="/"
              >spacetranslate.com</HeavyLink>
            </Text>
          </Block>
        )}
      </div>
    );
  }
}

export default compose(
  reduxForm({
    form: 'BetaSignupForm',
    onSubmit: async (variables, _, { error/* , signup, reset, destroy */ }) => {
      if (!error) {
        const { email } = variables;
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        fetch('https://api.spacetranslate.com/signup', {
          method: 'POST',
          headers,
          body: JSON.stringify({ email }),
        });
        // const { data } = await signup({ variables });
        // if (data.createUser.token) {
        //   localStorage.setItem('authToken', data.createUser.token);
        //   reset();
        //   destroy();
        //   navigateTo('/spaces');
        // }
      }
    },
    validate: values => {
      const errors = {};
      if (!values.email) {
        errors.email = 'Required';
      } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
        errors.email = 'Invalid email address';
      }
      if (!/[a-z]+/.test(values.password)) {
        errors.lowercase = true;
      }
      if (!values.password || values.password.length < 8) {
        errors.minlength = true;
      }
      if (!/\d+/.test(values.password)) {
        errors.number = true;
      }
      if (!/[`!"$?%^&*()_\-+={[}\]:;@'~#|\\<,>.?/]+/.test(values.password)) {
        errors.special = true;
      }
      if (!/[A-Z]+/.test(values.password)) {
        errors.uppercase = true;
      }
      return errors;
    },
  }),
)(BetaSignupForm);



// WEBPACK FOOTER //
// ./src/components/forms/BetaSignupForm.js